import { Container, Divider } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SectionLabel,
  SelectInput,
  StatusChip,
  SwitchInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatDate, getCookie, getErrors, wordCapitalize } from "utils";
import DialogForm from "./DialogForm";

function SubReporting() {
  const classes = globalStyles();
  const history = useHistory();
  const state = useSelector(data => data?.publisherId);
  const userLogin = getCookie("auth", `${process.env.REACT_APP_NAME}_user`);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 10,
    search: "",
    dsp_id: "",
    status: "",
    order: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [optionDsp, setOptionDsp] = useState([]);
  const [optionPublisher, setOptionPublisher] = useState([]);
  const [preloadId, setpreloadId] = useState(0);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const openModal = id => {
    setpreloadId(id || null);
    setModalVisible(true);
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/sub-reporting/list`,
        {
          headers,
          params: queryParams,
        }
      );

      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.limit || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const getOptionDSP = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publishers/list/${userLogin?.publisher?.publisher_id ||
          state?.publisherId}/dsps`,
        { headers }
      );
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.dsp_id,
        label: item?.name,
      }));
      setOptionDsp(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const getOptionPublisher = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/list-publisher?is_active_flag=true`,
        { headers }
      );
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.publisher_id,
        label: item?.name,
      }));
      setOptionPublisher(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSwitchStatus = async (event, id) => {
    const { checked } = event?.target;

    try {
      await axios.put(
        `${hardBaseUrl}/publisher/sub-reporting/change-status/${id}`,
        { is_active: checked },
        { headers }
      );
      ModalSuccess(
        `Succesfully ${checked ? "Activate" : "Deactivate"} Sub Reporting`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const deleteSubReporting = async id => {
    try {
      await axios.delete(`${hardBaseUrl}/publisher/sub-reporting/${id}`, {
        headers,
      });
      ModalSuccess("Succesfully Delete Sub Reporting").then(() =>
        getDataTable()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  const reFetch = () => {
    setModalVisible(false);
    getDataTable();
  };

  useEffect(() => {
    getOptionDSP();
    getOptionPublisher();
  }, []);
  useEffect(() => {
    getDataTable();
  }, [queryParams]);

  return (
    <Page className={classes.root} title="Sub Reporting">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my="16px"
        >
          <Grid item>
            <SectionLabel
              title="Sub Reporting"
              subTitle="This feature serves to leave DSP reports to other publishers"
            />
          </Grid>
          <Grid item>
            <Grid container alignItems="center" columnSpacing={1}>
              <Grid item>
                <AutoCompleteComponent
                  options={optionDsp}
                  label="DSP"
                  value={
                    optionDsp.find(
                      option => option.id === queryParams?.dsp_id
                    ) || null
                  }
                  onChange={value => handleChangeQueryParams(value, "dsp_id")}
                  size="small"
                  width={250}
                />
              </Grid>
              <Grid item>
                <SelectInput
                  label="Status"
                  value={queryParams?.status}
                  onChange={e =>
                    handleChangeQueryParams(e?.target?.value, "status")
                  }
                  options={listStatus}
                  optionKey="value"
                  optionLabel="name"
                  placeholder="None"
                  width={250}
                />
              </Grid>
              <Grid item>
                <PrimaryButton
                  label="Add Sub Reporting"
                  startIcon={<AddIcon />}
                  onClick={() => openModal()}
                  size="large"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable({ handleSwitchStatus })}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.limit}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "limit")
          }
          isHaveAction
          handleView={item =>
            history.push(
              `/admin/konfigurasi/sub-reporting/${item?.publisher_sub_reporting_id}`
            )
          }
          tooltipView="View"
          handleEdit={item => openModal(item?.publisher_sub_reporting_id)}
          tooltipEdit="Edit"
          disabledEdit={item => item?.status !== "waiting"}
          deleteConfirmation
          deleteConfirmationTitle="Delete Sub Reporting"
          handleDelete={item =>
            deleteSubReporting(item?.publisher_sub_reporting_id)
          }
          disabledDelete={item => item?.status !== "waiting"}
          tooltipDelete="Delete"
          skeletonHeight="764px"
        />

        {modalVisible && (
          <DialogForm
            open={modalVisible}
            onClose={() => setModalVisible(false)}
            optionPublisher={optionPublisher}
            optionDsp={optionDsp}
            reFetch={reFetch}
            preloadId={preloadId}
          />
        )}
      </Container>
    </Page>
  );
}
const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/sub-reporting",
  },
  {
    label: "Sub Reporting",
    active: true,
  },
];
const listStatus = [
  {
    name: "Waiting for Approval",
    value: "waiting",
  },
  {
    name: "Approved / Inactive",
    value: "approved",
  },
  {
    name: "Rejected",
    value: "rejected",
  },
];
const columnTable = ({ handleSwitchStatus }) => [
  {
    name: "all",
    title: "Status",
    renderText: item => (
      <SwitchInput
        checked={item?.status === "waiting" ? false : item.is_active}
        disabled={item?.status === "waiting"}
        onChange={e => handleSwitchStatus(e, item?.publisher_sub_reporting_id)}
      />
    ),
  },
  {
    name: "sub_reporting_publisher_name",
    title: "Publisher",
  },
  {
    name: "dsp_name",
    title: "DSP",
  },
  {
    name: "start_date",
    title: "Start Date",
    renderText: item => formatDate(item),
  },
  {
    name: "end_date",
    title: "End Date",
    renderText: item => formatDate(item),
  },
  {
    name: "status",
    title: "Approval Status",
    renderText: status => (
      <StatusChip
        type={
          status === "approved"
            ? "success"
            : status === "rejected"
            ? "danger"
            : status === "waiting"
            ? "warning"
            : ""
        }
        label={
          status == "waiting" ? "Waiting for Approval" : wordCapitalize(status)
        }
      />
    ),
  },
];

export default SubReporting;
